import { useEffect, useState } from 'react';

let firstLoad = true;

/**
 * (+) Cortina naranja con el logo al cambiar de página (≤ 450 ms). No se muestra en la primera carga
 * (para no retrasar el LCP) ni con prefers-reduced-motion (lo oculta el CSS).
 */
export default function PageCurtain({ logo }) {
  const [show] = useState(() => {
    const s = !firstLoad;
    firstLoad = false;
    return s;
  });
  const [done, setDone] = useState(false);
  useEffect(() => {
    if (!show) return undefined;
    const t = setTimeout(() => setDone(true), 500);
    return () => clearTimeout(t);
  }, [show]);
  if (!show || done) return null;
  return (
    <div className="t-curtain" aria-hidden="true">
      {logo ? <img src={logo} alt="" /> : null}
    </div>
  );
}
